import { render, staticRenderFns } from "./TaxPreparerInfo.vue?vue&type=template&id=1991a054&scoped=true&"
import script from "./TaxPreparerInfo.vue?vue&type=script&lang=js&"
export * from "./TaxPreparerInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaxPreparerInfo.vue?vue&type=style&index=0&id=1991a054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991a054",
  null
  
)

export default component.exports